import * as React from 'react';
import * as classNames from 'classnames';
import style from './StructureEditor.less';
import { WFormConfig, WFormData, WForm, WFormConfigItem } from '../forms/WFormFramework';
import form_data from './form_attribute.json';
import { StructureEditorOptsChooser } from './StructureEditorOptsChooser';
import { lazyInject } from '../../services/inversify';
import { StructureService } from '../../services/structure_service';
import { ContextService } from '../../services/context_service';
import { generateStructureKey } from './StructureKeyGen';
import { isFormatCompatible, isSummaryCompatible } from './helpers/TypeChecking';


export interface StructureEditorFormProps extends React.ClassAttributes<any> {
    modul: string;
    keySelected: string;
    entitySelected: string;
    structureData: any;
    typeCountInfo?: any;
    onFormCancel: () => any;
    onFormSave: (entityName: string, values: any) => any;
}

export interface StructureEditorFormState {
    OPTS_changed: any;
    setNewRef: boolean;
}

export class StructureEditorForm extends React.Component<StructureEditorFormProps, StructureEditorFormState>  {

    constructor(props: any) {
        super(props);
        this.state = {
            OPTS_changed: undefined,
            setNewRef: false
        };
        this.onFormCancel = this.onFormCancel.bind(this);
        this.onFormSave = this.onFormSave.bind(this);
        this.onSetOpts = this.onSetOpts.bind(this);
        this.getOptsChooser = this.getOptsChooser.bind(this);
        this.getRefInfo = this.getRefInfo.bind(this);
        this.validateField = this.validateField.bind(this);
        this.filterOptions = this.filterOptions.bind(this);
        this.checkDuplication = this.checkDuplication.bind(this);
        this.loadFormConfigOptRecht = this.loadFormConfigOptRecht.bind(this);
    }

    private formConfig: WFormConfig = new WFormConfig();
    private formData: WFormData = new WFormData();
    private customCloseHandler: () => void;

    @lazyInject(StructureService) private structureService: StructureService;
    @lazyInject(ContextService) private contextService: ContextService;

    componentWillMount() {
        this.formConfig = new WFormConfig();
        this.initForm();
        this.initData();
        // console.log('StructureEditorForm componentWillMount()');
        // console.log(this.formConfig);
    }
    initData() {
        if (this.props.structureData[this.props.entitySelected].ATTS) {
            // tslint:disable-next-line: max-line-length
            const attIndex = this.props.structureData[this.props.entitySelected].ATTS.findIndex((a: any) => a.KEY === this.props.keySelected);
            if (attIndex >= 0) {
                this.formData.setAllValues(this.props.structureData[this.props.entitySelected].ATTS[attIndex]);
            }
        }
    }
    initForm() {
        const form_data_copy = JSON.parse(JSON.stringify(form_data));  // Damit wir nicht die Original-Formdaten manipulieren

        // Schlüssel ausblenden. Der Schlüssel darf nur beim Anlegen geändert werden.
        if (this.props.keySelected) {
            const attIdx = form_data_copy.findIndex((a: any) => a.key === 'KEY');
            if (attIdx >= 0) {
                form_data_copy.splice(attIdx, 1);
            }
        }
        // Wenn wir typeCountInfo haben, eintragen ... ist dreckig aber geht nicht anders
        // console.log('TCI: ', this.props.typeCountInfo);
        if (this.props.typeCountInfo) {
            const typeElement = form_data_copy.find((a: any) => a.key === 'TYPE');
            // console.log('Type pre' , typeElement);
            typeElement.options.forEach((option: any) => {
                const countInfo = this.props.typeCountInfo[option.value] ? ' [ ' + this.props.typeCountInfo[option.value] + 'x ]' : '';
                option.label = option.label + countInfo;
            });
            // console.log('Type post' , typeElement);

        }

        this.formConfig.addData(form_data_copy); // --> form_data via Import (siehe oben)
        // Für die Options gibt es ein Custom - Item
        const item_opts: WFormConfigItem = {
            key: 'OPTS',
            label: 'Auswahl',
            typ: 'custom',
            custom_renderer: (data: any) => this.getRefInfo(),
            custom_component: this.getOptsChooser,
            custom_setCloseHandler: (callback: () => void) => this.customCloseHandler = callback
        };
        this.formConfig.addItem(item_opts);
        this.loadFormConfigOptRecht();
    }

    loadFormConfigOptRecht() {
        // console.log(this.formConfig);
        if (this.formConfig && Array.isArray(this.formConfig.items)) {
            const idx = this.formConfig.items.findIndex((a: any) => { return a.key === 'RECHT'; });
            if (idx >= 0) {
                const access = this.contextService.get('tableAccess');
                if (Array.isArray(access)) {
                    const opt: Array<any> = access.map((r: any) => {
                        return {
                            value: r.name,
                            label: r.info || r.name
                        };
                    });
                    if (opt) {
                        opt.unshift({
                            value: '',
                            label: ''
                        });
                        this.formConfig.items[idx].options = opt;
                    }
                }
            }
        }
    }

    getRefInfo() {
        const OPTS_use = this.state.OPTS_changed ? this.state.OPTS_changed : this.formData.getValue('OPTS');
        let refInfo = 'Keine Referenz gewählt';
        if (this.state.setNewRef) {
            refInfo = 'Neuer Katalog';
        } else if (OPTS_use) {
            let fieldData;
            if (typeof OPTS_use.MODUL === 'string' && OPTS_use.MODUL !== this.props.modul) {
                // Referenzen auf andere Module
                fieldData = this.structureService.getFieldInfo(OPTS_use.MODUL, OPTS_use.ENTITY, OPTS_use.INPUT);
                if (fieldData) {
                    refInfo = fieldData.entityTitel + ' (' + OPTS_use.MODUL + ') / ' + fieldData.fieldName;
                } else {
                    refInfo = OPTS_use.ENTITY_NAME + ' (' + OPTS_use.MODUL + ') / ' + OPTS_use.INPUT;
                }
            } else {
                fieldData = this.structureService.getFieldInfo(this.props.modul, OPTS_use.ENTITY, OPTS_use.INPUT);
                if (fieldData) {
                    refInfo = fieldData.entityTitel + ' / ' + fieldData.fieldName;
                } else if (OPTS_use.ENTITY) {
                    console.log(this.props.structureData);
                    if (this.props.structureData[OPTS_use.ENTITY]) {
                        refInfo = this.props.structureData[OPTS_use.ENTITY].TITEL + ' / Bezeichnung';
                    } else {
                        refInfo = 'Referenz "' + OPTS_use.ENTITY + '" NICHT gefunden.';
                    }
                }
            }
        }
        return refInfo;
    }
    getOptsChooser(): JSX.Element {
        console.log(this.state.OPTS_changed);
        return (<div>
            <StructureEditorOptsChooser
                OPTS={this.state.OPTS_changed ? this.state.OPTS_changed : this.formData.getValue('OPTS')}
                entitySelected={this.props.entitySelected}
                modul={this.props.modul}
                setNewRef={this.state.setNewRef}
                onSetOpts={this.onSetOpts}
                onAfterClose={() => this.customCloseHandler && this.customCloseHandler()}
            />
        </div>);
    }
    onFormSave(data: WFormData) {
        const values = data.getAllValues();
        if (!this.checkDuplication(values)) {
            return;
        }
        values.OPTS = this.state.OPTS_changed ? this.state.OPTS_changed : this.formData.getValue('OPTS');
        values.SET_NEW_REF = this.state.setNewRef;
        console.log('StructureEditorForm onFormSave', values);
        this.props.onFormSave(this.props.entitySelected, values);
    }
    checkDuplication(values: any) {
        if (this.props.entitySelected && this.props.structureData && this.props.structureData[this.props.entitySelected]
            && this.props.structureData[this.props.entitySelected].ATTS) {
            for (const attr of this.props.structureData[this.props.entitySelected].ATTS) {
                let msg = '';
                if (attr.KEY === values.KEY) {
                    if (!this.props.keySelected) {
                        msg = 'Schlüssel "' + values.KEY + '" existiert.';
                    }
                } else if (attr.NAME === values.NAME) {
                    msg = 'Bezeichnung "' + values.NAME + '" existiert.';
                }
                if (msg !== '') {
                    alert(msg);
                    return false;
                }
            }
        }
        return true;
    }
    onFormCancel() {
        /* this.setState({}, function () {
            this.navigationService.goTo(null, 0, -1);
        });
        */
        this.props.onFormCancel();
    }
    onSetOpts(OPTS: any, setNewRef: boolean) {
        if (!OPTS) {
            this.formData.setValue('OPTS', undefined);
        }
        this.formData.setValue('TYPE', 'INT');
        this.setState({ OPTS_changed: OPTS, setNewRef }, () => this.initForm());
        this.forceUpdate();
        if (this.customCloseHandler) {
            this.customCloseHandler();
        }
    }
    render() {
        // console.log('StructureEditorForm render formData');
        // console.log(this.formData);
        const opts = this.formData.getValue('OPTS');
        const type_item = this.formConfig.items.find((i: WFormConfigItem) => i.key === 'TYPE');
        if (opts && opts.ENTITY || this.state.OPTS_changed) {
            type_item.hidden = true;
        } else {
            type_item.hidden = false;
        }
        return (<WForm
            titel={'Attribut bearbeiten ' + '(' +
                (this.formData.getValue('NAME') ? this.formData.getValue('NAME') : 'Neues Attribut') + ')'}
            layout={this.props.modul === 'ber' ? 'ber' : 'sidebysideWIPS'}
            modeWarning='inline'
            config={this.formConfig}
            dataIn={this.formData}
            onFormSave={this.onFormSave}
            onFormCancel={this.onFormCancel}
            validateField={this.validateField}
            filterOptions={this.filterOptions}
        />);
    }
    filterOptions(options: Array<any>, key: string, data: any): Array<any> {
        // console.log('filterOptions: ', options, key, data);
        options = options.filter((opt) => {
            // Vorgehen: Wir suchen nur die falschen, alles andere ist true
            if (key === 'FORMAT') {
                const type = data.TYPE;
                const format = opt.VALUE;
                return isFormatCompatible(type, format);
            } else
                if (key === 'SUMMARY') {
                    const type = data.TYPE;
                    const summary = opt.VALUE;
                    return isSummaryCompatible(type, summary);
                }
            return true;
        });
        return options;
    }
    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any, doValidate: boolean) => void) {
        switch (key) {
            case 'NAME':
                // Der Schlüssel darf nur beim Anlegen geändert werden.
                if (!this.props.keySelected) {
                    const genKey = generateStructureKey(value);
                    // Ohne Validation, um den Fehler "Maximum update depth exceeded" zu vermeiden.
                    onValueChange('KEY', genKey, false);
                }
                break;
            case 'TYPE':
                const arr_items = [
                    this.formConfig.getItem('ALLOW_FUTURE'),
                    this.formConfig.getItem('DATE_AUTOFILL_DEAK'),
                    this.formConfig.getItem('DATE_AUTOUPDATE'),
                ];
                arr_items.forEach((item: any) => {
                    if (item) {
                        if (['DATE', 'DATETIME'].indexOf(value) === -1) {
                            item.hidden = true;
                        } else {
                            item.hidden = false;
                        }
                    }
                });
                break;
        }
        return '';
    }
}
